var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import { store } from '@/modules/main/store';
import { ACTIONS } from '@/modules/main/store/sessionModule';
import { i18n } from '@/modules/main/translations';
Vue.use(VueRouter);
var routes = [
    {
        path: '/activities',
        name: 'activities',
        redirect: 'activities/activity-stream',
        component: function () { return import(/* webpackChunkName: 'activities' */ './routes/overview/activities/ActivitiesPage.vue'); },
        children: [
            {
                path: 'activity-stream',
                name: 'activities.activity-stream',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.activityStream'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/overview/activities/ActivityStreamPage.vue'); },
            },
            {
                path: 'news/:uuid',
                name: 'activities.news.single',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.news'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/SinglePostPage.vue'); },
            },
            {
                path: 'news',
                name: 'activities.news',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.news'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/overview/activities/NewsPage.vue'); },
            },
            {
                path: 'neighbourhood-aid/:uuid',
                name: 'activities.neighbourhood-aid.single',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/SingleNeighbourhoodAidPage.vue'); },
            },
            {
                path: 'neighbourhood-aid',
                name: 'activities.neighbourhood-aid',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/overview/activities/NeighbourhoodAidPage.vue'); },
            },
            {
                path: 'marketplace/:uuid',
                name: 'activities.marketplace.single',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/SinglePostPage.vue'); },
            },
            {
                path: 'marketplace',
                name: 'activities.marketplace',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/overview/activities/MarketplacePage.vue'); },
            },
            {
                path: 'events/:uuid',
                name: 'activities.events.single',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.events'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/SingleEventPostPage.vue'); },
            },
            {
                path: 'events',
                name: 'activities.events',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.events'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/overview/activities/EventsPage.vue'); },
            },
            {
                path: 'surveys/:uuid',
                name: 'activities.surveys.single',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.surveys'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/SinglePostPage.vue'); },
            },
            {
                path: 'surveys',
                name: 'activities.surveys',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.surveys'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/overview/activities/SurveysPage.vue'); },
            },
            {
                path: 'documents/:uuid',
                name: 'activities.documents.single',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.documents'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/SinglePostPage.vue'); },
            },
            {
                path: 'documents',
                name: 'activities.documents',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('home.pageNav.documents'),
                },
                component: function () { return import(/* webpackChunkName: 'activities' */ './routes/overview/activities/DocumentsPage.vue'); },
            },
        ],
    },
    {
        path: '/chats/:userId?',
        name: 'chats',
        meta: {
            sideNav: 'section-1',
            hasMainStage: false,
            title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('sideNav.chats'),
        },
        component: function () { return import(/* webpackChunkName: 'chats' */ './routes/overview/ChatsPage.vue'); },
    },
    {
        path: '/settings',
        name: 'settings',
        redirect: 'settings/profile',
        component: function () { return import(/* webpackChunkName: 'settings' */ './routes/overview/settings/SettingsPage.vue'); },
        children: [
            {
                path: 'profile',
                name: 'settings.profile',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('sideNav.settings') + ' - ' + i18n.tc('settings.pageNav.profile'),
                },
                component: function () { return import(/* webpackChunkName: 'settings' */ './routes/overview/settings/ProfilePage.vue'); },
            },
            {
                path: 'profile/public',
                name: 'settings.profile.public',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('sideNav.settings') + ' - ' + i18n.tc('settings.pageNav.profile'),
                },
                component: function () { return import(/* webpackChunkName: 'settings' */ './routes/PublicProfilePage.vue'); },
            },
            {
                path: 'notifications',
                name: 'settings.notifications',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('sideNav.settings') + ' - ' + i18n.tc('settings.pageNav.notifications'),
                },
                component: function () { return import(/* webpackChunkName: 'settings' */ './routes/overview/settings/NotificationsPage.vue'); },
            },
            {
                path: 'group-subscriptions',
                name: 'settings.group-subscriptions',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('sideNav.settings') + ' - ' + i18n.tc('settings.pageNav.groupSubscriptions'),
                },
                component: function () { return import(/* webpackChunkName: 'settings' */ './routes/overview/settings/GroupSubscriptionsPage.vue'); },
            },
            {
                path: 'ignores',
                name: 'settings.ignores',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('sideNav.settings') + ' - ' + i18n.tc('settings.pageNav.ignores'),
                },
                component: function () { return import(/* webpackChunkName: 'settings' */ './routes/overview/settings/IgnoresPage.vue'); },
            },
            {
                path: 'surrounding',
                name: 'settings.surroundings',
                meta: {
                    sideNav: 'section-1',
                    title: i18n.tc('sideNav.overview') + ' - ' + i18n.tc('sideNav.settings') + ' - ' + i18n.tc('settings.pageNav.surroundings'),
                },
                component: function () { return import(/* webpackChunkName: 'settings' */ './routes/overview/settings/SurroundingsPage.vue'); },
            },
        ],
    },
    // neighbourhood
    {
        name: 'neighbourhood',
        path: '/neighbourhood',
        redirect: '/neighbourhood/activities/activity-stream',
        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/NeighbourhoodPage.vue'); },
        children: [
            {
                name: 'neighbourhood.activities',
                path: 'activities',
                redirect: '/neighbourhood/activities/activity-stream',
                component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/activities/ActivitiesPage.vue'); },
                children: [
                    {
                        path: 'activity-stream',
                        name: 'neighbourhood.activities.activity-stream',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.activityStream'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/activities/ActivityStreamPage.vue'); },
                    },
                    {
                        path: 'news/:uuid',
                        name: 'neighbourhood.activities.news.single',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.news'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'news',
                        name: 'neighbourhood.activities.news',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.news'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/activities/NewsPage.vue'); },
                    },
                    {
                        path: 'neighbourhood-aid/:uuid',
                        name: 'neighbourhood.activities.neighbourhood-aid.single',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'neighbourhood-aid',
                        name: 'neighbourhood.activities.neighbourhood-aid',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/activities/NeighbourhoodAidPage.vue'); },
                    },
                    {
                        path: 'marketplace/:uuid',
                        name: 'neighbourhood.activities.marketplace.single',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'marketplace',
                        name: 'neighbourhood.activities.marketplace',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/activities/MarketplacePage.vue'); },
                    },
                    {
                        path: 'events/:uuid',
                        name: 'neighbourhood.activities.events.single',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.events'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/SingleEventPostPage.vue'); },
                    },
                    {
                        path: 'events',
                        name: 'neighbourhood.activities.events',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.events'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/activities/EventsPage.vue'); },
                    },
                    {
                        path: 'surveys/:uuid',
                        name: 'neighbourhood.activities.surveys.single',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.surveys'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'surveys',
                        name: 'neighbourhood.activities.surveys',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.surveys'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/activities/SurveysPage.vue'); },
                    },
                    {
                        path: 'documents/:uuid',
                        name: 'neighbourhood.activities.documents.single',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.documents'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'documents',
                        name: 'neighbourhood.activities.documents',
                        meta: {
                            sideNav: 'section-2',
                            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('home.pageNav.documents'),
                        },
                        component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/activities/DocumentsPage.vue'); },
                    },
                ],
            },
            {
                name: 'neighbourhood.information',
                path: 'information/:id?',
                meta: {
                    sideNav: 'section-2',
                    title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('sideNav.information'),
                },
                component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/InformationPage.vue'); },
            },
            {
                name: 'neighbourhood.my-surrounding',
                path: 'my-surrounding',
                meta: {
                    sideNav: 'section-2',
                    title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('sideNav.mySurrounding'),
                },
                component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/MySurroundingPage.vue'); },
            },
            {
                name: 'neighbourhood.neighbours',
                path: 'neighbours',
                meta: {
                    sideNav: 'section-2',
                    title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('sideNav.neighbours'),
                },
                component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/NeighboursPage.vue'); },
            },
            {
                name: 'neighbourhood.admin',
                path: 'admin',
                meta: {
                    sideNav: 'section-2',
                    title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('sideNav.administration'),
                },
                component: function () { return import(/* webpackChunkName: 'neighbourhood' */ './routes/neighbourhood/NeighbourhoodAdministrationPage.vue'); },
            },
        ],
    },
    // neighbourhood
    {
        name: 'nachbarschaft.information',
        path: '/nachbarschaft/information/:platform',
        meta: {
            sideNav: 'section-6',
            public: true,
            title: i18n.tc('sideNav.neighbourhood') + ' - ' + i18n.tc('sideNav.information'),
        },
        component: function () { return import(/* webpackChunkName: 'nachbarschaft' */ './routes/nachbarschaft/InformationPage.vue'); },
    },
    // community
    {
        name: 'community',
        path: '/community',
        redirect: 'community.activities',
        component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/CommunityPage.vue'); },
        children: [
            {
                name: 'community.activities',
                path: 'activities',
                redirect: '/community/activities/activity-stream',
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/activities/ActivitiesPage.vue'); },
                children: [
                    {
                        path: 'activity-stream',
                        name: 'community.activities.activity-stream',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.activityStream'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/activities/ActivityStreamPage.vue'); },
                    },
                    {
                        path: 'news/:uuid',
                        name: 'community.activities.news.single',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.news'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'news',
                        name: 'community.activities.news',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.news'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/activities/NewsPage.vue'); },
                    },
                    {
                        path: 'neighbourhood-aid/:uuid',
                        name: 'community.activities.neighbourhood-aid.single',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'neighbourhood-aid',
                        name: 'community.activities.neighbourhood-aid',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/activities/NeighbourhoodAidPage.vue'); },
                    },
                    {
                        path: 'marketplace/:uuid',
                        name: 'community.activities.marketplace.single',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'marketplace',
                        name: 'community.activities.marketplace',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/activities/MarketplacePage.vue'); },
                    },
                    {
                        path: 'events/:uuid',
                        name: 'community.activities.events.single',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.events'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/SingleEventPostPage.vue'); },
                    },
                    {
                        path: 'events',
                        name: 'community.activities.events',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.events'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/activities/EventsPage.vue'); },
                    },
                    {
                        path: 'surveys/:uuid',
                        name: 'community.activities.surveys.single',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.surveys'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'surveys',
                        name: 'community.activities.surveys',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.surveys'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/activities/SurveysPage.vue'); },
                    },
                    {
                        path: 'documents/:uuid',
                        name: 'community.activities.documents.single',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.documents'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'documents',
                        name: 'community.activities.documents',
                        meta: {
                            sideNav: 'section-3',
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.documents'),
                        },
                        component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/activities/DocumentsPage.vue'); },
                    },
                ],
            },
            {
                name: 'community.information',
                path: 'information',
                meta: {
                    sideNav: 'section-3',
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.information'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/InformationPage.vue'); },
            },
            {
                name: 'community.groups',
                path: 'groups',
                meta: {
                    sideNav: 'section-3',
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.groups'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/GroupsPage.vue'); },
            },
            {
                name: 'community.groups.details',
                path: 'groups/:uuid',
                meta: {
                    sideNav: 'section-3',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.groups'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/GroupDetailsPage.vue'); },
            },
            {
                name: 'community.clubs',
                path: 'clubs',
                meta: {
                    sideNav: 'section-3',
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.clubs'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/ClubsPage.vue'); },
            },
            {
                name: 'community.clubs.details',
                path: 'clubs/:uuid',
                meta: {
                    sideNav: 'section-3',
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.clubs'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/GroupDetailsPage.vue'); },
            },
            {
                name: 'community.business',
                path: 'businesses',
                meta: {
                    sideNav: 'section-3',
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.business'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/BusinessPage.vue'); },
            },
            {
                name: 'community.businesses.details',
                path: 'businesses/:uuid',
                meta: {
                    sideNav: 'section-3',
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.business'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/GroupDetailsPage.vue'); },
            },
            {
                name: 'community.institutions',
                path: 'institutions',
                meta: {
                    sideNav: 'section-3',
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.institutions'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/InstitutionsPage.vue'); },
            },
            {
                name: 'community.institutions.details',
                path: 'institutions/:uuid',
                meta: {
                    sideNav: 'section-3',
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.institutions'),
                },
                component: function () { return import(/* webpackChunkName: 'community' */ './routes/community/GroupDetailsPage.vue'); },
            },
        ],
    },
    // gemeinden
    {
        name: 'gemeinden',
        path: '/gemeinden/:platform',
        redirect: 'gemeinden.activities',
        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/community/CommunityPage.vue'); },
        meta: {
            public: true,
        },
        children: [
            {
                name: 'gemeinden.activities',
                path: 'activities',
                redirect: '/gemeinden/:platform/activities/activity-stream',
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/activities/ActivitiesPage.vue'); },
                meta: {
                    public: true,
                },
                children: [
                    {
                        path: 'activity-stream',
                        name: 'gemeinden.activities.activity-stream',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.activityStream'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/activities/ActivityStreamPage.vue'); },
                    },
                    {
                        path: 'news/:uuid',
                        name: 'gemeinden.activities.news.single',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.news'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'news',
                        name: 'gemeinden.activities.news',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.news'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/activities/NewsPage.vue'); },
                    },
                    {
                        path: 'neighbourhood-aid/:uuid',
                        name: 'gemeinden.activities.neighbourhood-aid.single',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'neighbourhood-aid',
                        name: 'gemeinden.activities.neighbourhood-aid',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/activities/NeighbourhoodAidPage.vue'); },
                    },
                    {
                        path: 'marketplace/:uuid',
                        name: 'gemeinden.activities.marketplace.single',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'marketplace',
                        name: 'gemeinden.activities.marketplace',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/activities/MarketplacePage.vue'); },
                    },
                    {
                        path: 'events/:uuid',
                        name: 'gemeinden.activities.events.single',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.events'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/SingleEventPostPage.vue'); },
                    },
                    {
                        path: 'events',
                        name: 'gemeinden.activities.events',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.events'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/activities/EventsPage.vue'); },
                    },
                    {
                        path: 'surveys/:uuid',
                        name: 'gemeinden.activities.surveys.single',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.surveys'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'surveys',
                        name: 'gemeinden.activities.surveys',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.surveys'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/activities/SurveysPage.vue'); },
                    },
                    {
                        path: 'documents/:uuid',
                        name: 'gemeinden.activities.documents.single',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.documents'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'documents',
                        name: 'gemeinden.activities.documents',
                        meta: {
                            sideNav: 'section-5',
                            public: true,
                            title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('home.pageNav.documents'),
                        },
                        component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/activities/DocumentsPage.vue'); },
                    },
                ],
            },
            {
                name: 'gemeinden.information',
                path: 'information',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.information'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/InformationPage.vue'); },
            },
            {
                name: 'gemeinden.groups',
                path: 'groups',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.groups'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/GroupsPage.vue'); },
            },
            {
                name: 'gemeinden.groups.details',
                path: 'groups/:uuid',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.groups'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/GroupDetailsPage.vue'); },
            },
            {
                name: 'gemeinden.clubs',
                path: 'clubs',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.clubs'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/ClubsPage.vue'); },
            },
            {
                name: 'gemeinden.clubs.details',
                path: 'clubs/:uuid',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.clubs'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/GroupDetailsPage.vue'); },
            },
            {
                name: 'gemeinden.business',
                path: 'businesses',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.business'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/BusinessPage.vue'); },
            },
            {
                name: 'gemeinden.business.details',
                path: 'businesses/:uuid',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.business'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/GroupDetailsPage.vue'); },
            },
            {
                name: 'gemeinden.institutions',
                path: 'institutions',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.institutions'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/InstitutionsPage.vue'); },
            },
            {
                name: 'gemeinden.institutions.details',
                path: 'institutions/:uuid',
                meta: {
                    sideNav: 'section-5',
                    public: true,
                    title: i18n.tc('sideNav.community') + ' - ' + i18n.tc('sideNav.institutions'),
                },
                component: function () { return import(/* webpackChunkName: 'gemeinden' */ './routes/gemeinden/GroupDetailsPage.vue'); },
            }
        ],
    },
    // membership
    {
        name: 'membership',
        path: '/membership',
        redirect: 'membership/activities/:groupId?',
        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/MembershipPage.vue'); },
        children: [
            {
                name: 'membership.activities',
                path: 'activities/:groupId?',
                redirect: 'activities/:groupId?/activity-stream',
                component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/activities/ActivitiesPage.vue'); },
                children: [
                    {
                        path: 'activity-stream',
                        name: 'membership.activities.activity-stream',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.activityStream'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/activities/ActivityStreamPage.vue'); },
                    },
                    {
                        path: 'news/:uuid',
                        name: 'membership.activities.news.single',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.news'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'news',
                        name: 'membership.activities.news',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.news'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/activities/NewsPage.vue'); },
                    },
                    {
                        path: 'neighbourhood-aid/:uuid',
                        name: 'membership.activities.neighbourhood-aid.single',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'neighbourhood-aid',
                        name: 'membership.activities.neighbourhood-aid',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.neighbourhoodAid'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/activities/NeighbourhoodAidPage.vue'); },
                    },
                    {
                        path: 'marketplace/:uuid',
                        name: 'membership.activities.marketplace.single',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'marketplace',
                        name: 'membership.activities.marketplace',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.marketplace'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/activities/MarketplacePage.vue'); },
                    },
                    {
                        path: 'events/:uuid',
                        name: 'membership.activities.events.single',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.events'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/SingleEventPostPage.vue'); },
                    },
                    {
                        path: 'events',
                        name: 'membership.activities.events',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.events'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/activities/EventsPage.vue'); },
                    },
                    {
                        path: 'surveys/:uuid',
                        name: 'membership.activities.surveys.single',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.surveys'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'surveys',
                        name: 'membership.activities.surveys',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.surveys'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/activities/SurveysPage.vue'); },
                    },
                    {
                        path: 'documents/:uuid',
                        name: 'membership.activities.documents.single',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.documents'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/SinglePostPage.vue'); },
                    },
                    {
                        path: 'documents',
                        name: 'membership.activities.documents',
                        meta: {
                            sideNav: 'section-4',
                            title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('home.pageNav.documents'),
                        },
                        component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/activities/DocumentsPage.vue'); },
                    },
                ],
            },
            {
                name: 'membership.information',
                path: 'information/:groupId?',
                meta: {
                    sideNav: 'section-4',
                    title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('sideNav.information'),
                },
                component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/InformationPage.vue'); },
            },
            {
                name: 'membership.members',
                path: 'members/:groupId?',
                meta: {
                    sideNav: 'section-4',
                    title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('sideNav.members'),
                },
                component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/MembersPage.vue'); },
            },
            {
                name: 'membership.admin',
                path: 'admin/:groupId?',
                meta: {
                    sideNav: 'section-4',
                    title: i18n.tc('sideNav.membership') + ' - ' + i18n.tc('sideNav.administration'),
                },
                component: function () { return import(/* webpackChunkName: 'membership' */ './routes/membership/MembershipAdministrationPage.vue'); },
            },
        ],
    },
    // gruppe
    {
        name: 'gruppe.information',
        path: '/gruppe/information/:group',
        meta: {
            sideNav: 'section-7',
            public: true,
            title: i18n.tc('sideNav.groups') + ' - ' + i18n.tc('sideNav.information'),
        },
        component: function () { return import(/* webpackChunkName: 'gruppe' */ './routes/gruppe/InformationPage.vue'); },
    },
    // vereine
    {
        name: 'vereine.information',
        path: '/vereine/information/:group',
        meta: {
            sideNav: 'section-8',
            public: true,
            title: i18n.tc('sideNav.clubs') + ' - ' + i18n.tc('sideNav.information'),
        },
        component: function () { return import(/* webpackChunkName: 'gruppe' */ './routes/gruppe/InformationPage.vue'); },
    },
    // institutionen
    {
        name: 'institutionen.information',
        path: '/institutionen/information/:group',
        meta: {
            sideNav: 'section-9',
            public: true,
            title: i18n.tc('sideNav.institutions') + ' - ' + i18n.tc('sideNav.information'),
        },
        component: function () { return import(/* webpackChunkName: 'gruppe' */ './routes/gruppe/InformationPage.vue'); },
    },
    // gewerbe
    {
        name: 'gewerbe.information',
        path: '/gewerbe/information/:group',
        meta: {
            sideNav: 'section-10',
            public: true,
            title: i18n.tc('sideNav.business') + ' - ' + i18n.tc('sideNav.information'),
        },
        component: function () { return import(/* webpackChunkName: 'gruppe' */ './routes/gruppe/InformationPage.vue'); },
    },
    // gemeindeverwaltungen
    {
        name: 'gemeindeverwaltungen.information',
        path: '/gemeindeverwaltungen/information/:group',
        meta: {
            sideNav: 'section-11',
            public: true,
            title: i18n.tc('sideNav.local_government') + ' - ' + i18n.tc('sideNav.information'),
        },
        component: function () { return import(/* webpackChunkName: 'gruppe' */ './routes/gruppe/InformationPage.vue'); },
    },
    {
        path: '/contact',
        name: 'contact',
        component: function () { return import(/* webpackChunkName: 'general' */ './routes/ContactPage.vue'); },
        meta: {
            public: true,
            customMainStage: 'footer_kontakt.jpg',
            title: i18n.tc('userBar.linkContact'),
        },
    },
    {
        path: '/help',
        name: 'help',
        component: function () { return import(/* webpackChunkName: 'general' */ './routes/HelpPage.vue'); },
        meta: {
            public: true,
            customMainStage: 'footer_hilfe.jpg',
            title: i18n.tc('userBar.linkHelp'),
        },
    },
    {
        path: '/legal',
        name: 'legal',
        component: function () { return import(/* webpackChunkName: 'general' */ './routes/LegalPage.vue'); },
        meta: {
            public: true,
            customMainStage: 'footer_rechtliches.jpg',
            title: i18n.tc('userBar.linkLegal'),
        },
    },
    {
        path: '/imprint',
        name: 'imprint',
        component: function () { return import(/* webpackChunkName: 'general' */ './routes/ImprintPage.vue'); },
        meta: {
            public: true,
            customMainStage: 'footer_impressum.jpg',
            title: i18n.tc('userBar.linkImprint'),
        },
    },
    {
        path: '/profile/:id',
        name: 'profile.public',
        component: function () { return import(/* webpackChunkName: 'profile' */ './routes/PublicProfilePage.vue'); },
    },
    {
        path: '/search',
        name: 'search',
        meta: {
            hasMainStage: false,
            public: true,
        },
        component: function () { return import(/* webpackChunkName: 'search' */ './routes/SearchPage.vue'); },
    },
    {
        path: '*',
        name: '404',
        component: function () { return import('@/router/routes/Page404.vue'); },
    },
];
export var router = new VueRouter({
    mode: 'history',
    routes: routes,
});
router.beforeEach(function (to, from, next) { return __awaiter(void 0, void 0, void 0, function () {
    var loadSessionSuccess, loginpath, staticSection;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                loadSessionSuccess = true;
                if (!!store.state.session.user.data.first_name) return [3 /*break*/, 2];
                return [4 /*yield*/, store.dispatch(ACTIONS.LOAD_SESSION)];
            case 1:
                loadSessionSuccess = _a.sent();
                _a.label = 2;
            case 2:
                // if the route is public we could optionally use the user session data, otherwise just go forward
                if (!to.meta.public) {
                    if (loadSessionSuccess) {
                        next();
                    }
                    else {
                        loginpath = window.location.pathname;
                        staticSection = ['fuerenand', 'belvita', '', 'login', 'password'];
                        if (!staticSection.includes(loginpath.split('/')[1])) {
                            window.location.replace('/login?from=' + loginpath);
                        }
                    }
                }
                else {
                    next();
                }
                return [2 /*return*/];
        }
    });
}); });
var DEFAULT_TITLE = 'Fuerenand';
router.afterEach(function (to, from) {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(function () {
        document.title = DEFAULT_TITLE;
        if (to.meta.title) {
            document.title = to.meta.title + ' | ' + DEFAULT_TITLE;
        }
    });
});
